export const FE = 'FE';
export const BE = 'BE';
export const RM_FE = 'RM_FE';
export const CURRENT_APP = 'FE';
